import {useBestDeals} from "../hooks/useBestDeals";
import BestDealCard from "./card";
import CardSkeleton from "../cardSkeleton";
const BestDeal = () => {
    const { bestDeals,error,loadMore,hasMore,isFetchingNextPage,isInitialLoad} = useBestDeals({page:1});
    return (
        <div className="w-full px-10 py-4">
            <div className="w-full grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6">
                {
                    isInitialLoad? Array.from({length:12}).map((i,_)=>
                            <CardSkeleton key={_}/>
                        ) :
                    bestDeals?.map(bestDeal => (
                        <BestDealCard key={bestDeal.id} bestDeal={bestDeal} />))
                }
            </div>
            {hasMore && (
                <div className="text-center mt-6">
                    <button
                        onClick={() => loadMore()}
                        disabled={isFetchingNextPage}
                        className="px-4 py-2 text-white rounded hover:bg-yellow-600 !bg-yellow-500 outline-0 border-none">
                        {isFetchingNextPage ? 'Loading...' : 'Load More'}
                    </button>
                </div>
            )}

            {error && <div className="text-red-500 text-center mt-4">{error}</div>}
        </div>
    );
}

export default BestDeal;